import React, { useContext, useMemo } from 'react';
import { Checkbox as AntdCheckbox } from 'antd';
import { TableContext } from './context';

const Checkbox = (props) => {
    const { title, row } = props;
    const {
        filterData,
        rowKey,
        propCheckedRows,
        checkboxTitleDisabled,
        checkboxDisabled,
        setTableCheckedRows,
        checkedRows,
        onChangeCheckedRowsRef
    } = useContext(TableContext);

    const checkableData = useMemo(() => (
        filterData.filter((item) => !checkboxDisabled?.includes(item[rowKey]))
    ), [filterData, checkboxDisabled, rowKey]);
    const onChangeAll = ({ target: { checked } }) => {
        const result = checked ? checkableData.map((item) => item[rowKey]) : [];
        if (!propCheckedRows) {
            setTableCheckedRows(result);
        }
        onChangeCheckedRowsRef.current?.(result);
    };
    const onChange = ({ target: { checked } }) => {
        const result = checkedRows.filter((key) => key !== row[rowKey]);
        if (checked) {
            result.push(row[rowKey]);
        }
        if (!propCheckedRows) {
            setTableCheckedRows(result);
        }
        onChangeCheckedRowsRef.current?.(result);
    };

    return title ? (
        <AntdCheckbox
            className="relative -top-[2px]"
            indeterminate={checkedRows.length && checkedRows.length < checkableData.length}
            checked={checkedRows.length && checkedRows.length === checkableData.length}
            disabled={checkboxTitleDisabled || !checkableData.length}
            onChange={onChangeAll}
        />
    ) : (
        <AntdCheckbox
            className="relative -top-[1px]"
            checked={checkedRows.includes(row[rowKey])}
            disabled={checkboxDisabled?.includes(row[rowKey])}
            onChange={onChange}
        />
    );
};

export default Checkbox;
